import React from 'react';
import ModernNode from './ModernNode';
import { NODE_TYPES } from '../../config/nodeConfig';

const CodeNode = (props) => {
  return <ModernNode {...props} nodeType={NODE_TYPES.CODE} />;
};

export default CodeNode;